import { useEffect, useRef } from "react";
import logger from "../utils/logger";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";

const API = `${(process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "")}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }

      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        // Store token and user via context
        login(res.data.user, res.data.session_token);
        navigate("/dashboard", { replace: true, state: { user: res.data.user } });
      } catch (err) {
        logger.error("Auth callback error:", err);
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#0A0A0A" }}>
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-2 border-[#00E5FF] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-[#A1A1AA]">Authenticating...</p>
      </div>
    </div>
  );
}
